import { useContainer } from '../../useContainer';
import { ProjectApi, ToastStateHandler } from '../../../api';
import { useTranslation } from '../../useTranslation';
import { ProjectStatus } from '@cyberlabrs/helpers';

interface UpdateProjectStatusDto {
    projectStatus: ProjectStatus;
}

const useHttpUpdateProjectStatus = () => {
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const toastHandler = useContainer(ToastStateHandler);
    const { t } = useTranslation('newNotifications');

    const exec = (projectId: string, projectStatus: ProjectStatus, onSuccess?: () => void, onError?: () => void) => {
        const body: UpdateProjectStatusDto = { projectStatus };

        const { exec: apiExec, abort } = projectApi.updateProjectStatus({
            params: { id: projectId },
            body,
            onSuccess: () => {
                toastHandler.push('success', t('projects.projectUpdateTitle'), t('projects.projectStatusUpdated'));
                onSuccess?.();
            },
            onError: () => {
                toastHandler.push('error', t('projects.projectUpdateTitle'), t('projects.projectStatusUpdateFailed'));
                onError?.();
            },
        });

        apiExec();
        return abort;
    };

    return { exec };
};

export default useHttpUpdateProjectStatus;
